import React from 'react';

import { Avatar } from 'bsa-ui';

import { activityTypeForActivityTypeId } from '../../constants';
import ActivityType from '../ActivityType';
import ActivityTypeIcon from '../ActivityTypeIcon';
import Button from '../Button';
import { Col, Row } from '../bsaComponents';
import styles from './ActivityTypeLogLink.less';

interface ActivityTypeLogLinkProps {
  activityTypeId: number;
  onClick: () => void;
  detailInfo: React.ReactNode;
}

const ActivityTypeLogLink = ({
  activityTypeId,
  onClick,
  detailInfo,
}: ActivityTypeLogLinkProps) => (
  <Row
    onClick={onClick}
    className={styles.activityLink}
    type="flex"
    align="middle"
  >
    <Col>
      <Avatar className={styles.activityIconContainer} size="large">
        <ActivityTypeIcon activityTypeId={activityTypeId} />
      </Avatar>
    </Col>
    <Col className={styles.activityName}>
      <div>
        <Button type="link">
          <ActivityType
            activityType={
              activityTypeForActivityTypeId[
                activityTypeId as keyof typeof activityTypeForActivityTypeId
              ]
            }
          />
        </Button>
        {detailInfo && <div className={styles.summary}>{detailInfo}</div>}
      </div>
    </Col>
  </Row>
);

ActivityTypeLogLink.defaultProps = {
  onClick: () => {},
  detailInfo: undefined,
};

export default ActivityTypeLogLink;
